export default __webpack_public_path__ + "static/media/movieMobile.b634614d.jpg";